import React, { useState } from "react";

const doctors = [
  {
    name: "Dr. Emily Chen",
    specialty: "General Practice",
    rating: 5.0,
    reviews: 127,
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    times: ["10:00 AM", "11:30 AM", "1:00 PM"],
  },
  {
    name: "Dr. Michael Rodriguez",
    specialty: "Internal Medicine",
    rating: 5.0,
    reviews: 89,
    image: "https://randomuser.me/api/portraits/men/45.jpg",
    times: ["10:00 AM", "11:30 AM", "1:00 PM"],
  },
  {
    name: "Dr. Sarah Thompson",
    specialty: "Family Medicine",
    rating: 5.0,
    reviews: 156,
    image: "https://randomuser.me/api/portraits/women/65.jpg",
    times: ["10:00 AM", "11:30 AM", "1:00 PM"],
  },
];

function AppointmentBooking() {
  const [selectedAppointment, setSelectedAppointment] = useState(null);

  const handleSlotSelect = (doctor, time) => {
    const today = new Date();
    const formattedDate = today.toLocaleDateString();
    setSelectedAppointment({
      doctor: doctor.name,
      time,
      date: `Today, ${formattedDate}`,
    });
  };

  return (
    <div className="bg-slate-50 min-h-screen flex items-center justify-center py-10">
      <div className="bg-white rounded-xl shadow-md p-6 w-full max-w-6xl">
        {/* Header */}
        <h2 className="text-2xl font-bold text-gray-800 mb-1">
          Book Your Appointment
        </h2>
        <p className="text-gray-500 mb-4">
          Select a doctor and available time slot
        </p>
        <hr className="mb-6" />

        {/* Doctor Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {doctors.map((doctor, idx) => (
            <div
              key={idx}
              className="border border-gray-200 rounded-xl p-5 text-center shadow-sm hover:shadow-md transition"
            >
              <img
                src={doctor.image}
                alt={doctor.name}
                className="w-16 h-16 rounded-full mx-auto mb-4 object-cover"
              />
              <h3 className="text-lg font-semibold text-gray-900">
                {doctor.name}
              </h3>
              <p className="text-gray-500">{doctor.specialty}</p>
              <p className="flex items-center justify-center text-yellow-500 mt-1">
                <span className="text-lg">★</span>
                <span className="ml-1 text-gray-700 font-medium">
                  {doctor.rating.toFixed(1)}
                </span>
                <span className="ml-1 text-gray-500">
                  ({doctor.reviews} reviews)
                </span>
              </p>

              {/* Time Slots */}
              <div className="flex flex-wrap gap-2 mt-4 justify-center">
                {doctor.times.map((time, tIdx) => (
                  <button
                    key={tIdx}
                    onClick={() => handleSlotSelect(doctor, time)}
                    className={`border border-gray-300 rounded-md px-4 py-1 text-sm font-medium transition 
                      ${
                        selectedAppointment?.doctor === doctor.name &&
                        selectedAppointment?.time === time
                          ? "bg-blue-600 text-white border-blue-600"
                          : "hover:bg-blue-50 hover:border-blue-400"
                      }`}
                  >
                    {time}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Appointment Confirmation */}
        {selectedAppointment && (
          <div className="mt-8 p-6 bg-blue-50 rounded-lg border border-blue-200">
            <h3 className="text-lg font-bold text-blue-800 mb-2">
              Appointment Confirmation
            </h3>
            <p className="text-gray-700">
              <strong>Doctor:</strong> {selectedAppointment.doctor}
            </p>
            <p className="text-gray-700">
              <strong>Time:</strong> {selectedAppointment.time}
            </p>
            <p className="text-gray-700">
              <strong>Date:</strong> {selectedAppointment.date}
            </p>
            <button
              onClick={() => alert("Appointment Confirmed!")}
              className="mt-4 w-full bg-blue-600 text-white py-2 rounded-md font-medium hover:bg-blue-700 transition"
            >
              Confirm Appointment
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default AppointmentBooking;
